// src/services/languageService.js
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import i18n from '../i18n'; 
import English from '../language/english.json';

export const LoadStaticEnglishLanguage = () => {
  if (!i18n.hasResourceBundle('english', 'translation')) {
    i18n.addResourceBundle('english', 'translation', English, true, true);
  }

  return 'english';
};

export const LoadLanguage = (languageStr) => { 
  return new Promise((resolve, reject) => {
    if (!languageStr || languageStr === 'english') return resolve(LoadStaticEnglishLanguage()); // Default fallback

    if (i18n.hasResourceBundle(languageStr, 'translation')) {
      return resolve(languageStr);
    }

    HttpServices.LanguagePost({
      url: userModuleURL.getLanguageJson,
      body: { language: languageStr },
      successCallback: (data) => {
        i18n.addResourceBundle(languageStr, 'translation', data, true, true);
        resolve(languageStr);
      },
      failureCallback: (err) => {
        console.error(`Failed to load: ${languageStr}`, err);
        resolve(LoadStaticEnglishLanguage()); 
      }
    });
  });
};
